//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BottomNav from "../components/BottomNav";
import CertificateBox from "../components/certificateBox";

export default {
    name: "welfare",
    components: {CertificateBox},
    data() {
        return {
            id: 0,
            birthdayNotice: {},
            saving: false
        }
    },
    methods: {
        getBirthdayNoticeById() {
            abp.ajax.get('/api/services/app/Birthday/GetBirthdayNoticeById?id=' + this.id).then(res => {
                this.birthdayNotice = {};
                this.birthdayNotice = res.data.result;
            }).finally(() => {
                this.loading = false
            })
        },
        onSave() {
            if (this.birthdayNotice.presentType == 0) {
                this.sendPoint()
            } else {
                this.sendCoupon()
            }
        },
        sendPoint() {
            this.saving = true
            abp.ajax.post('/api/services/app/Birthday/SendPoint?noticeId=' + this.id).then(res => {
                this.$toast.success('领取成功');
                this.$router.push({
                    name: 'home'
                });
            }).finally(() => {
                this.saving = false
            })
        },
        sendCoupon() {
            var mid = localStorage.getItem('MemberId');
            if (!mid || mid == null || mid == undefined) {
                return;
            }
            var params = {
                userId: parseInt(mid),
                couponId: this.birthdayNotice.couponId,
                status: 1,
                receiveTime: new Date(),
                source: this.birthdayNotice.channelType,
                sourceId: this.birthdayNotice.id
            };
            // console.log(item);
            // console.log(params);
            // return;
            this.saving = true;
            abp.ajax.post('/api/services/app/Birthday/SendCoupon', params).then(res => {
                this.$toast.success('领取成功');
                this.$router.push({
                    name: 'home'
                });
            }).finally(() => {
                this.saving = false;
            })
        }
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        if (this.id > 0) {
            this.getBirthdayNoticeById();
        }

    }
}
